export enum ESupportOutsourcingContractModificationType {
  RENEW_CONTRACT = "renew_contract",
  MODIFY_CONTRACT = "modify_contract",
  TERMINATE_CONTRACT = "terminate_contract",
}
